angular

	.module 'App.Repository'
	.factory 'LayoutTemplateRepository', ['BaseRepository', (BaseRepository) ->
		class LayoutTemplateRepository extends BaseRepository
			@resource = '/layout_templates'
			@isRestricted = true

		return new LayoutTemplateRepository
	]
